<template>
  <div class="account-ranking-list">
    <div
      v-for="(item, index) in items"
      :key="item.name"
      class="ranking-item"
    >
      <div v-if="showIndex" class="ranking-index">{{ index + 1 }}</div>
      <div class="ranking-name" v-tooltip.top="item.name || ''">{{ item.name }}</div>
      <div class="ranking-bar-container">
        <div
          class="ranking-bar"
          :style="{
            width: `${(item.value / maxValue) * 100}%`,
            backgroundColor: item.color || '#4F46E5'
          }"
        ></div>
      </div>
      <div class="ranking-value">{{ item.displayValue || item.value }}</div>
    </div>
  </div>
</template>

<script>
import Tooltip from 'primevue/tooltip';

export default {
  name: "AccountRankingList",
  directives: {
    tooltip: Tooltip
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxValue() {
      if (!this.items || this.items.length === 0) return 1;
      return Math.max(...this.items.map((item) => item.value));
    },
  },
};
</script>

<style lang="scss" scoped>
.account-ranking-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.ranking-item {
  display: grid;
  grid-template-columns: 30px 150px 1fr 60px;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.ranking-index {
  width: 24px;
  height: 24px;
  background-color: #f0f3f8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.ranking-name {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}

.ranking-bar-container {
  width: 100%;
  height: 8px;
  background-color: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
}

.ranking-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.ranking-value {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  text-align: right;
}
</style>
